import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS,
  ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION,
} from '../../constants/actions';
import {
  addCharacteristicSuccessAction,
  deleteCharacteristicSuccessAction,
  fetchCharacteristicsSuccessAction,
  getCharacteristicSuccessAction,
} from '../../actions/instances/characteristics';
import Api from '../../services/Api';

function* fetchCharacteristics() {
  const { filters } = yield select(state => state.characteristics);
  let query = '';
  if (filters.dynasties.length > 0) {
    query += filters.dynasties.map(dynasty => `&dynasties_ids[]=${dynasty}`);
  }
  if (filters.types.length > 0) {
    query += filters.types.map(type => `&types_ids[]=${type}`);
  }
  if (filters.cities.length > 0) {
    query += filters.cities.map(city => `&cities_ids[]=${city}`);
  }
  if (filters.tags.length > 0) {
    query += filters.tags.map(tag => `&tags_ids[]=${tag}`);
  }
  const { status, data } = yield Api.get(`instances/building-characteristics?per_page=50${query}`, false);
  if (status === 200) {
    yield put(fetchCharacteristicsSuccessAction(data.data));
  }
}

function* getCharacteristic(action) {
  const { status, data } = yield Api.get(`instances/building-characteristic/${action.payload}`, false);
  if (status === 200) {
    yield put(getCharacteristicSuccessAction(data));
  }
}

function* addCharacteristic(action) {
  const { status, data } = yield Api.post('instances/building-characteristics', action.payload, false);
  if (status === 200) {
    yield put(addCharacteristicSuccessAction(data));
  }
}

function* deleteCharacteristic(action) {
  const { status } = yield Api.delete(`instances/building-characteristics/${action.payload}`, false);
  if (status === 204) {
    yield put(deleteCharacteristicSuccessAction());
  }
}

export default function* characteristicsSagas() {
  yield takeEvery([
    ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION,
    ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS,
  ], fetchCharacteristics);
  yield takeEvery(ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION, getCharacteristic);
  yield takeEvery(ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION, addCharacteristic);
  yield takeEvery(ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION, deleteCharacteristic);
}
